<form [formGroup]="formGroup">
    <div class="card-content">
        <app-patient-search-component (selected)="onPatientSelected($event)">
        </app-patient-search-component>
        <mat-spinner *ngIf="loading"></mat-spinner>
        <div *ngIf="patient && !loading">
            <app-patient-view-component (patientChange)="onPatientChange($event)" [patientview]="patient">
            </app-patient-view-component>
            <mat-error *ngIf="f.Patient.errors && f.Patient.errors.invalidPatientViewResultWeb">
                Seleccione si el paciente confirma la visualización de resultados en la web
            </mat-error>
        </div>
    </div>
</form>